import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, CloseButton, Form, Modal, Spinner } from 'react-bootstrap';

/** 审批驳回：必填原因，写入 approval.approvalSuggestions */
const ApprovalRejectReasonModal = ({
	show,
	onHide,
	onConfirm,
	confirmWaiting = false,
	hint = '驳回后申请人可在再次申请时看到此说明，请简明写清原因。',
	placeholder = '例如：价格低于底价未说明、客户信息不完整…',
}) => {
	const [reason, setReason] = useState('');
	const trimmed = reason.trim();
	const canConfirm = trimmed.length > 0 && !confirmWaiting;

	useEffect(() => {
		if (show) setReason('');
	}, [show]);

	return (
		<Modal
			show={show}
			onHide={onHide}
			backdrop='static'
			keyboard={false}
			centered
			className='modal-nested-stack'
			backdropClassName='modal-backdrop-nested'
		>
			<Modal.Header>
				<Modal.Title>填写驳回原因</Modal.Title>
				<CloseButton onClick={onHide} disabled={confirmWaiting} />
			</Modal.Header>
			<Modal.Body>
				<p className='mb-2 text-600 fs-10'>{hint}</p>
				<Form.Group controlId='approval-reject-reason'>
					<Form.Label className='fw-semibold'>
						驳回原因 <span className='text-danger'>*</span>
					</Form.Label>
					<Form.Control
						as='textarea'
						rows={4}
						value={reason}
						onChange={(event) => setReason(event.target.value)}
						placeholder={placeholder}
						disabled={confirmWaiting}
						autoFocus
						maxLength={500}
					/>
					<div className='d-flex justify-content-between mt-1'>
						{trimmed.length === 0 ? <Form.Text className='text-danger'>请填写驳回原因后再确认</Form.Text> : <span />}
						<Form.Text className='text-500'>{trimmed.length}/500</Form.Text>
					</div>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='secondary' onClick={onHide} disabled={confirmWaiting}>
					<span className='fs-9'>取消</span>
				</Button>
				<Button
					variant='danger'
					disabled={!canConfirm}
					onClick={() => {
						if (!canConfirm) return;
						onConfirm(trimmed);
					}}
				>
					<span className='fs-9'>{confirmWaiting ? <Spinner size='sm' /> : '确定驳回'}</span>
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

ApprovalRejectReasonModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	confirmWaiting: PropTypes.bool,
	hint: PropTypes.string,
	placeholder: PropTypes.string,
};

export default ApprovalRejectReasonModal;
